import { API, axiosInstance } from "lib";

export const getFirm = (data = {}) => {
  return axiosInstance
    .post(API.GET_SETTINGS_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getSingleFirm = (data = {}) => {
  return axiosInstance
    .post(API.GET_SINGLE_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const createFirm = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_SETTINGS_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const updateFirm = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_SETTINGS_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getUserFirm = (data = {}) => {
  return axiosInstance
    .post(API.GET_USER_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};


export const getToFirm = (data = {}) => {
  return axiosInstance
    .post(API.GET_TO_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const addAssociateFirmApi = (data = {}) => {
  return axiosInstance
    .post(API.ADD_ASSOCIATED_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const updateAssociateFirmApi = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_ASSOCIATED_FIRM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};
